export default {
  methods: {
    isUnavailable(id) {
      if (!this.ruleBlockUnavailable) return false
      const el = document.getElementById(id)
      return el ? el.classList.contains('unavailable') : false
    },
    getGroupCount(container, prefix) {
      const pattern = new RegExp(`^${prefix}-\\d+$`)
      const numbers = Array.from(container.querySelectorAll(`[id^="${prefix}-"]`))
        .map(el => el.getAttribute('id'))
        .filter(elId => pattern.test(elId))
        .map(elId => parseInt(elId.split('-')[1], 10))
      return numbers.length ? Math.max(...numbers) : 0
    },
    getPosition(n, totalCount) {
      const rowsPerColumn = Math.floor(totalCount / 2)
      const hasOverflow = totalCount % 2 !== 0
      const overflowN = rowsPerColumn + 1

      if (n <= rowsPerColumn) return { col: 0, row: n - 1, overflow: false, rowsPerColumn }
      if (hasOverflow && n === overflowN) return { overflow: true, rowsPerColumn }
      const row = hasOverflow ? n - overflowN - 1 : n - rowsPerColumn - 1
      return { col: 1, row, overflow: false, rowsPerColumn }
    },

    // ---- Adjazenz-Kernlogik OHNE unavailable-Check ----
    areAdjacentCore(idA, idB) {
      if (!idA || !idB) return false

      const elA = document.getElementById(idA)
      const elB = document.getElementById(idB)
      if (!elA || !elB) return false

      const tafelA = this.getTafelNode(elA)
      const tafelB = this.getTafelNode(elB)

      const sameTafel = tafelA && tafelB && tafelA === tafelB
      if (!sameTafel && !this.ruleTafelUebergreifendErlaubt) return false
      if (!tafelA || !tafelB) return false

      const prefixA = idA.split('-')[0]
      const prefixB = idB.split('-')[0]

      if (prefixA === prefixB) {
        const tischNode = this.getTischNode(elA)
        if (!tischNode || !tischNode.contains(elB)) return false

        const totalCount = this.getGroupCount(tischNode, prefixA)
        const numA = parseInt(idA.split('-')[1], 10)
        const numB = parseInt(idB.split('-')[1], 10)

        const a = this.getPosition(numA, totalCount)
        const b = this.getPosition(numB, totalCount)
        const rowsPerColumn = a.rowsPerColumn

        if (!a.overflow && !b.overflow) {
          const verticalNeighbor = a.col === b.col && Math.abs(a.row - b.row) === 1
          const horizontalNeighbor = a.col !== b.col && a.row === b.row
          return verticalNeighbor || horizontalNeighbor
        }
        if (a.overflow !== b.overflow) {
          const regular = a.overflow ? b : a
          return regular.row === rowsPerColumn - 1
        }
        return false
      }

      if (!this.ruleTischUebergreifendErlaubt) return false
      if (!sameTafel) return false

      const tischA = this.getTischNode(elA)
      const tischB = this.getTischNode(elB)
      if (!tischA || !tischB || tischA === tischB) return false

      const orderA = parseInt(prefixA, 10)
      const orderB = parseInt(prefixB, 10)
      if (isNaN(orderA) || isNaN(orderB) || Math.abs(orderA - orderB) !== 1) return false

      const totalCountA = this.getGroupCount(tischA, prefixA)
      const totalCountB = this.getGroupCount(tischB, prefixB)

      const isSingleA = totalCountA === 1
      const isSingleB = totalCountB === 1

      if (isSingleA && orderA >= orderB) return false
      if (isSingleB && orderB >= orderA) return false

      const numA = parseInt(idA.split('-')[1], 10)
      const numB = parseInt(idB.split('-')[1], 10)

      const a = isSingleA
        ? { isLastRow: true, isFirstRow: false, sameColAlways: true }
        : (() => {
            const pos = this.getPosition(numA, totalCountA)
            return {
              isLastRow: pos.overflow || pos.row === pos.rowsPerColumn - 1,
              isFirstRow: !pos.overflow && pos.row === 0,
              sameColAlways: pos.overflow,
              col: pos.overflow ? null : pos.col
            }
          })()

      const b = isSingleB
        ? { isLastRow: false, isFirstRow: true, sameColAlways: true }
        : (() => {
            const pos = this.getPosition(numB, totalCountB)
            return {
              isLastRow: pos.overflow || pos.row === pos.rowsPerColumn - 1,
              isFirstRow: !pos.overflow && pos.row === 0,
              sameColAlways: pos.overflow,
              col: pos.overflow ? null : pos.col
            }
          })()

      const sameCol = a.sameColAlways || b.sameColAlways || a.col === b.col

      if (orderA < orderB) return sameCol && a.isLastRow && b.isFirstRow
      return sameCol && b.isLastRow && a.isFirstRow
    },

    areAdjacentById(idA, idB) {
      if (this.ruleBlockUnavailable && (this.isUnavailable(idA) || this.isUnavailable(idB))) return false
      return this.areAdjacentCore(idA, idB)
    },

    hasAdjacentUnavailable(id) {
      const el = document.getElementById(id)
      if (!el) return false
      const tafelNode = this.getTafelNode(el)
      if (!tafelNode) return false

      const allIdsInTafel = Array.from(tafelNode.querySelectorAll('path[id]')).map(e => e.getAttribute('id'))

      return allIdsInTafel.some(otherId => {
        if (otherId === id) return false
        if (!this.isUnavailable(otherId)) return false
        return this.areAdjacentCore(id, otherId)
      })
    },
    isTafelEdgeElement(id) {
      const el = document.getElementById(id)
      if (!el) return false
      const tafelNode = this.getTafelNode(el)
      if (!tafelNode) return false

      const tischNode = this.getTischNode(el)
      if (!tischNode) return false

      const orderedTische = this.getOrderedTischNodes(tafelNode)
      if (orderedTische.length === 0) return false

      const firstTisch = orderedTische[0]
      const lastTisch = orderedTische[orderedTische.length - 1]

      const prefix = id.split('-')[0]
      const totalCount = this.getGroupCount(tischNode, prefix)
      const num = parseInt(id.split('-')[1], 10)
      const isSingle = totalCount === 1
      const pos = isSingle ? null : this.getPosition(num, totalCount)

      const isFirstRow = isSingle ? false : (!pos.overflow && pos.row === 0)
      const isLastRow = isSingle ? true : (pos.overflow || pos.row === pos.rowsPerColumn - 1)

      if (tischNode === firstTisch && isFirstRow) return true
      if (tischNode === lastTisch && isLastRow) return true
      return false
    },
    // Inverse von getPosition: welche Nummer liegt an (col, row)?
    getNumberAt(col, row, totalCount) {
      const rowsPerColumn = Math.floor(totalCount / 2)
      const hasOverflow = totalCount % 2 !== 0
      if (col < 0 || col > 1 || row < 0 || row >= rowsPerColumn) return null
      if (col === 0) return row + 1
      return (hasOverflow ? rowsPerColumn + 1 : rowsPerColumn) + 1 + row
    },

    // Alle tatsächlich vorhandenen Platznummern eines Tisches
    getExistingNumbers(tischNode, prefix) {
      const pattern = new RegExp(`^${prefix}-\\d+$`)
      const nums = Array.from(tischNode.querySelectorAll(`[id^="${prefix}-"]`))
        .map(el => el.getAttribute('id'))
        .filter(elId => pattern.test(elId))
        .map(elId => parseInt(elId.split('-')[1], 10))
      return new Set(nums)
    },

    // Liegt der Platz direkt neben einer Lücke (Nummer fehlt im SVG)?
    hasAdjacentHole(id) {
      const el = document.getElementById(id)
      if (!el) return false
      const tischNode = this.getTischNode(el)
      if (!tischNode) return false

      const prefix = id.split('-')[0]
      const totalCount = this.getGroupCount(tischNode, prefix)
      if (totalCount <= 1) return false

      const existing = this.getExistingNumbers(tischNode, prefix)
      const isMissing = n => n !== null && n <= totalCount && !existing.has(n)

      const num = parseInt(id.split('-')[1], 10)
      const pos = this.getPosition(num, totalCount)
      const rows = pos.rowsPerColumn
      const hasOverflow = totalCount % 2 !== 0
      const overflowN = rows + 1

      // Overflow-Platz: grenzt oben an die letzte Reihe beider Spalten
      if (pos.overflow) {
        return isMissing(this.getNumberAt(0, rows - 1, totalCount)) ||
               isMissing(this.getNumberAt(1, rows - 1, totalCount))
      }

      const neighbors = [
        this.getNumberAt(pos.col, pos.row - 1, totalCount),
        this.getNumberAt(pos.col, pos.row + 1, totalCount),
        this.getNumberAt(1 - pos.col, pos.row, totalCount)
      ]
      if (neighbors.some(isMissing)) return true

      // Letzte Reihe: fehlt der Overflow-Platz darunter?
      if (hasOverflow && pos.row === rows - 1 && isMissing(overflowN)) return true

      return false
    },

    canStartSelection(id) {
      if (!this.ruleMustStartAtEdge) return true
      return this.isTafelEdgeElement(id) ||
             this.hasAdjacentUnavailable(id) ||
             this.hasAdjacentHole(id)
    },
    getIslands(ids) {
      const remaining = new Set(ids)
      const islands = []

      while (remaining.size > 0) {
        const start = remaining.values().next().value
        const island = new Set([start])
        remaining.delete(start)

        const queue = [start]
        while (queue.length > 0) {
          const current = queue.shift()
          for (const other of Array.from(remaining)) {
            if (this.areAdjacentById(current, other)) {
              island.add(other)
              remaining.delete(other)
              queue.push(other)
            }
          }
        }
        islands.push(Array.from(island))
      }

      return islands
    },

    // Eine Auswahl ist gültig, wenn jede ihrer Inseln für sich zusammenhängend
    // ist und (falls die Regel aktiv ist) einen gültigen Startpunkt enthält
    isValidSelectionState(ids) {
      if (ids.length <= 1) return true
      if (!this.ruleMustStayConnected) return true

      const islands = this.getIslands(ids)

      return islands.every(island => {
        if (!this.ruleMustStartAtEdge) return true
        return island.some(id => this.canStartSelection(id))
      })
    },

    // Prüft, ob es IRGENDEINEN freien, direkt angrenzenden Platz an der
    // aktuellen Auswahl gibt. Nur wenn das false ist, darf eine neue,
    // unverbundene Insel begonnen werden.
    hasReachableAvailableSeat() {
      if (this.selectedElements.length === 0) return false
      if (!this.svgRoot) return false

      const allPaths = Array.from(this.svgRoot.querySelectorAll('path[id]'))

      return allPaths.some(path => {
        const id = path.getAttribute('id')
        if (!id) return false
        if (this.selectedElements.includes(id)) return false
        if (this.isUnavailable(id)) return false
        return this.selectedElements.some(selId => this.areAdjacentById(selId, id))
      })
    },
  }
}
